<template>
  <div class="box" style="background-color:#eeeeee; border: 1px solid #cccccc; width: 280px;">
    <div
        @click="expanded = !expanded"
        class="icon"
        :class="{ 'icon-open': expanded, 'icon-closed': !expanded}"
        :title="expanded ? 'Collapse' : 'Show all'"
    >
      <img src="./arrow.png" height="20" width="20">
    </div>
    <div v-if="currentLanguage==0" class="title" style="font-size: 14pt;">Bodeneigenschaften</div>
    <div v-else-if="currentLanguage==1" class="title" style="font-size: 14pt;">Propriétés du sol</div>
    <div v-else-if="currentLanguage==2" class="title" style="font-size: 14pt;">Soil Properties</div>

    <div id="error-div" style="color: red;" v-if="err.length > 0">{{err}}</div>
    <div v-if="expanded">
    <a
        class="panel-block is-active"
        :class="{'active': layerGroup && item.id === layerGroup.id}"
        style="font-size: 11pt;"
        v-for="(item, key) in catalogs"
        :key="key"
        @click="select(item)"
    >
      <catalog-item :item="item"></catalog-item>
    </a>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { soilmapUrl } from "@/data";
import CatalogItem from "@/components/CatalogItem";

export default {
  name: "Catalog",
  components: {CatalogItem},
  data () {
    return {
      catalogs: [],
      err: '',
      expanded: true,
    }
  },
  computed: {
    /*token() {
      return this.$store.state.token
    },*/
    layerGroup() {
      return this.$store.state.layerGroup
    },
    currentLanguage() {
      return this.$store.getters.currentLanguage
    }
  },
  methods: {
    select(item) {
      this.$store.commit('setLayerGroup', item)
    },
    getData() {
      let mapservice = soilmapUrl.de + '/layers?f=pjson'

      if(this.currentLanguage == 0) {
        mapservice = soilmapUrl.de + '/layers?f=pjson'
      } else if (this.currentLanguage == 1)  {
        mapservice = soilmapUrl.fr + '/layers?f=pjson'

      } else if (this.currentLanguage == 2) {
        mapservice = soilmapUrl.en + '/layers?f=pjson'
      }

      this.$store.dispatch('getLegend')
      axios.get(mapservice)
          .then(res => {
            if (res.data.error) {
              this.err =  'Error ' + res.data.error.code + ':  ' + res.data.error.message
            } else {
              this.err = ''
              let parents = res.data.layers.filter(layer => layer.type === 'Group Layer' || layer.id === 42)
              parents.forEach(parent => {
                parent.subLayers = parent.subLayers.map(subLayer => res.data.layers.find(layer => layer.id === subLayer.id))
              })
              this.catalogs = parents
            }
          })
          .catch(err => console.log(err))
    }
  },
  watch: {
    /*token: {
      handler() {
        this.getData()
      },
      immediate: true
    },*/
    currentLanguage: {
      handler() {
        this.getData()
      },
      immediate: true
    }
  }
}
</script>

<style scoped>
.active {
  background-color: aquamarine;
}

.icon-open {
  transform: rotate(90deg);
}
.icon-closed {
  transform: rotate(270deg);
}
.icon {
  cursor: pointer;
  top: 0;
  right: 0;
  float: right;
  font-size: 12pt;
  width: 20px;
  height: 20px;
  opacity: 0.7;
}
.icon:hover {
  opacity: 1;
}

</style>
